/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import custom component
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForManufacturer } from './gridComponents/tableHead';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  radioGroupLabelNameAudit,
  radioGroupLabelNamePlan,
  radioGroupLabelNameSelectBy,
  rebateProgramLabelName,
  quarterLabelName,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  redirectURLLink,
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  handleErrorMessages,
  getQuarterData,
  getAuditTypeDropDownList,
  getManufacturerList,
  getSearchInvoiceByCriteriaList,
  setSearchInvoiceAuditTab,
  setSearchScreenTab,
  setInvoiceAuditDetailTab,
  getFindNDCLevelDetailList,
  postSaveOrUpdate,
  getNDCAuditDescription,
  dispatchPagValue,
  dispatchNDCAuditDes,
  dispatchFindNDCLevelDetails,
  setPervSearchInvoiceRedux,
  dispatchInvoiceCriteriaList,
  getPlanTypeRadioBoxValue,
  getRebateProgramDropdownList,
  setChangesDataList,
} from '../store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const InvoiceAuditsSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  /* dispatch function */
  const setSearchInvoiceAudit = (value) =>
    dispatch(setSearchInvoiceAuditTab(value));
  // use Selector function

  const searchInvoiceAuditTabData = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.searchInvoiceAuditObj
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.quarter
  );
  const fetchManufacturerList = useSelector(
    (state) => state.sharedState.InvoiceAuditsReducer.manufacturerList
  );
  const perviousInvoiceCriteriaList = useSelector(
    (state) =>
      state.sharedState.InvoiceAuditsReducer?.perviousInvoiceCriteriaRedux
  );

  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.InvoiceAuditsReducer?.errorMessagesInRedux
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [pendingPayload, setPendingPayload] = useState(null);

  // variable deceleration
  const searchCompObj = searchInvoiceAuditTabData?.state?.searchTypeState;
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const gridRef = React.useRef();
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [selectManufacturer, setSelectManufacturer] = useState({});
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [labelerFullScreen, setLabelerFullScreen] = useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [ndcSearchVal, setNdcSearchVal] = useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  // eslint-disable-next-line no-nested-ternary
  const [searchType, setSearchType] = useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = useState(
    errorMessagesOfSearchTypeComp
  );
  const [state, setState] = useState(
    searchInvoiceAuditTabData?.state
      ? searchInvoiceAuditTabData.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? userDefaults?.rebateProgramCd
            : '-1',
          selectBy: 'A',
          auditTypeCd: 'ALL',
          quarterValue: null,
          selectedAuditType: '-1',
          clearedIndex: 0,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  // handle all plan type get service
  React.useEffect(() => {
    handleScrollToEvent();
    getPlanTypeRadioBoxValue().then((res) => {
      const planList =
        res?.length > 0 &&
        res?.map((obj) => {
          return {
            name:
              obj?.codeValueID?.codeValue === 'FD'
                ? 'Medicaid'
                : obj.shortDescription,
            value: obj.codeValueID.codeValue,
          };
        });
      setPlanTypeOptions(planList);
    });
  }, []);

  // set common dropdown list
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getRebateProgramDropdownList(state?.planTypeCd).then((res) => {
      let list = [];
      if (
        res?.status === constantMessageData.STATUS_MSG &&
        res?.message === constantMessageData.SUCCESS_MSG
      ) {
        if (!_.isEmpty(res.data)) {
          list = _.map(res.data, (val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
        }
      }
      setRebateProgramList(
        list.sort((key, val) =>
          key.name.toLowerCase().localeCompare(val.name.toLowerCase())
        )
      );
    });
  }, [state?.planTypeCd]);
  // Apply user default rebate program after dropdown options load
  React.useEffect(() => {
    if (
      userDefaults?.rebateProgramCd &&
      rebateProgramList?.length > 0 &&
      (state?.rebateProgramCd === '-1' || !state?.rebateProgramCd)
    ) {
      const exists = rebateProgramList.some(
        (item) => item.id === userDefaults.rebateProgramCd
      );
  
      if (exists) {
        setState((prev) => ({
          ...prev,
          rebateProgramCd: userDefaults.rebateProgramCd,
        }));
      }
    }
  }, [
    userDefaults?.rebateProgramCd,
    rebateProgramList,
  ]);
  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    setSearchInvoiceAudit({
      fullScreenView: fullScreenView,
      state: { ...state, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      setSearchInvoiceAudit({
        fullScreenView: true,
        state: { ...state, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearchInvoiceAudit({
        fullScreenView: false,
        state: state,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);
  // handling onPage load call service
  React.useEffect(() => {
    if (
      searchInvoiceAuditTabData &&
      Object.keys(searchInvoiceAuditTabData).length === 0
    ) {
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      dispatch(getQuarterData());
    } else if (searchInvoiceAuditTabData?.fullScreenView) {
      setFullScreenView(searchInvoiceAuditTabData.fullScreenView);
    }
    getAuditTypeDropDownList({
      domainKey: 'AUDIT_TYPE_CD',
      codeValue: 'I',
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // set common dropdown list

  // set Manufacturer list
  React.useEffect(() => {
    setManufacturerList(fetchManufacturerList);
  }, [fetchManufacturerList]);

  // handing Quarter format
  const handleQuarterFormate = (value) => {
    const data = value;
    const d = data.split('');
    d.splice(4, 0, 'Q');
    const d1 = d.join('').split('Q').reverse('');
    d1.splice(1, 0, 'Q');
    const output = d1.join('');
    return output;
  };
  // set initial quarte Value
  React.useEffect(() => {
    let quarter = '';
    if (
      searchInvoiceAuditTabData &&
      searchInvoiceAuditTabData.state &&
      searchInvoiceAuditTabData.state.quarterValue === null
    ) {
      if (
        getQuarterDataValue?.status === constantMessageData.STATUS_MSG &&
        getQuarterDataValue?.message === constantMessageData.SUCCESS_MSG
      ) {
        const receivedQuarter = getQuarterDataValue.data;
        if (receivedQuarter) {
          quarter = handleQuarterFormate(receivedQuarter);
        }
      }
      setState({ ...state, quarterValue: quarter });
      setSearchInvoiceAudit({
        fullScreenView: fullScreenView,
        state: { ...state, quarterValue: quarter },
      });
    }
  }, [getQuarterDataValue]);
  React.useEffect(() => {
    let quarter = '';
    if (searchInvoiceAuditTabData?.state?.quarterValue === null) {
      quarter = getQuarterDataValue;
      if (quarter) {
        setState({
          ...state,
          quarterValue: autoFormateDate(quarter?.toUpperCase()),
        });

        setSearchInvoiceAudit({
          fullScreenView: fullScreenView,
          state: {
            ...state,
            quarterValue: autoFormateDate(quarter?.toUpperCase()),
          },
        });
      }
    }
  }, [getQuarterDataValue]);
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/invoiceAudits', true);
    } else {
      tabHighLigther('/invoiceAudits', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // click on filter icon after call
  const handleClearFilter = () => {
    if (manufacturerList && manufacturerList.length > 0 && gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };
  // Calling API for Manufacturer List
  const getManufactureListData = (name, value) => {
    dispatch(
      getManufacturerList(
        // eslint-disable-next-line no-nested-ternary
        name === 'rebateProgramCd'
          ? {
              rebateProgramCd: value === '-1' ? null : value,
              qtr: state.quarterValue,
            }
          : name === 'quarter'
          ? {
              rebateProgramCd:
                state.rebateProgramCd === '-1' ? null : state.rebateProgramCd,
              qtr: value?.toUpperCase(),
            }
          : {
              rebateProgramCd:
                state.rebateProgramCd === '-1' ? null : state.rebateProgramCd,
              qtr: state.quarterValue,
            }
      )
    );
    handleClearFilter();
  };
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    if (name === 'selectBy' && value !== state.selectBy) {
      setState({
        ...state,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });

      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');

      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setSearchInvoiceAudit({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      let errorMsgWithoutSearch = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      setErrorMsgFromSearchType([]);
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setSearchInvoiceAudit({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    } else if (name === 'auditTypeCd' && value !== 'Selected') {
      setState({ ...state, [name]: value, selectedAuditType: '-1' });
      setSearchInvoiceAudit({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value, selectedAuditType: '-1' },
      });
    } else {
      setState({ ...state, [name]: value });
      setSearchInvoiceAudit({
        fullScreenView: fullScreenView,
        state: { ...state, [name]: value },
      });
    }
    if (name === 'selectBy' && value === 'M') {
      getManufactureListData();
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );

        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );
        if (state.selectBy === 'M') {
          getManufactureListData(
            'rebateProgramCd',
            value === '-1' ? null : value
          );
        }
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) =>
            item.field !== 'quarter' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' &&
              item.field !== 'resultNotFound' &&
              item.field !== 'NoSelectedRow'
          );
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          setSearchInvoiceAudit({
            fullScreenView: fullScreenView,
            state: {
              ...state,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            },
          });
          if (state.selectBy === 'M') {
            getManufactureListData('quarter', value?.toUpperCase());
          }
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' &&
              item.field !== 'resultNotFound' &&
              item.field !== 'NoSelectedRow'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'quarter' &&
            item.field !== 'resultNotFound' &&
            item.field !== 'NoSelectedRow'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  // set Error messages
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearchInvoiceAudit({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };
  // redirect view detail page
const handleViewDetailFunction = async (data) => {
  let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
  if (
    state?.rebateProgramCd !== null &&
    state?.rebateProgramCd !== '-1' &&
    checkQuarterValidation(state.quarterValue)
  ) {
    localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    const Obj = {
      auditType:
        state.auditTypeCd === 'Selected'
          ? state.selectedAuditType
          : state.auditTypeCd,
      rebateProgramCode: state.rebateProgramCd,
      quarter: state.quarterValue,
      clearedIndex: state.clearedIndex ? 1 : 0,
      unclearedIndex: state.clearedIndex ? 0 : 1,
      asCode: state.selectBy,
    };

    let drugSeqArr = [];

    if (state.selectBy === 'NDC' && data?.length) {
      drugSeqArr = data.map((elem) => elem.drugSeqNum);

      if (drugSeqArr.length > 1000) {
        setPendingPayload({ Obj, drugSeqArr });
        setConfirmAction(true);
        return;
      }
    }

    const resultData = await dispatch(
      state.selectBy === 'M'
        ? getSearchInvoiceByCriteriaList({ ...Obj, mfgId: data.mfgId })
        : state.selectBy === 'NDC'
        ? getSearchInvoiceByCriteriaList({
            ...Obj,
            drugSeqNum: drugSeqArr,
          })
        : getSearchInvoiceByCriteriaList(Obj)
    );

    const response = resultData?.searchInvoiceByCriteriaList;

    if (response?.invoiceAuditGridResponse2?.length > 0) {
      dispatch(dispatchFindNDCLevelDetails([]));
      dispatch(dispatchNDCAuditDes([]));
      dispatch(setInvoiceAuditDetailTab({}));
      dispatch(getFindNDCLevelDetailList([], 'update'));
      dispatch(getNDCAuditDescription([], 'update'));
      dispatch(setChangesDataList([]));
      dispatch(dispatchPagValue(1));
      dispatch(postSaveOrUpdate(null));
      dispatch(setPervSearchInvoiceRedux(response));
      dispatch(setSearchScreenTab(searchInvoiceAuditTabData));

      localErr = localErr.filter(
        (item) =>
          item.field !== 'resultNotFound' && item.field !== 'NoSelectedRow'
      );

      redirectURLLink(
        '/invoiceAuditsDetail',
        'Invoice Audits Detail',
        history,
        dispatch
      );
    } else {
      dispatch(dispatchInvoiceCriteriaList(perviousInvoiceCriteriaList));

      localErr = localErr.filter((item) => item.field !== 'resultNotFound');

      localErr.push({
        field: 'resultNotFound',
        errorType: 'resultNotFound',
        errorComponent: 'searchTypeComponent',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });

      handleScrollToEvent();
    }
  } else {
    if (
      state?.rebateProgramCd === null ||
      state?.rebateProgramCd === undefined ||
      state?.rebateProgramCd === '-1'
    ) {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else if (state.quarterValue === '') {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(state.quarterValue)) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
  }

  dispatch(
    handleErrorMessages({
      searchScreenErrors: [...new Set(localErr)],
      detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors || [],
    })
  );
};
const callSearchAPI = async (Obj, drugSeqArr = [], data) => {
  const resultData = await dispatch(
    state.selectBy === 'M'
      ? getSearchInvoiceByCriteriaList({ ...Obj, mfgId: data.mfgId })
      : state.selectBy === 'NDC'
      ? getSearchInvoiceByCriteriaList({
          ...Obj,
          drugSeqNum: drugSeqArr,
        })
      : getSearchInvoiceByCriteriaList(Obj)
  );

  const response = resultData && resultData.searchInvoiceByCriteriaList;

  if (response?.invoiceAuditGridResponse2?.length > 0) {
    dispatch(dispatchFindNDCLevelDetails([]));
    dispatch(dispatchNDCAuditDes([]));
    dispatch(setInvoiceAuditDetailTab({}));
    dispatch(getFindNDCLevelDetailList([], 'update'));
    dispatch(getNDCAuditDescription([], 'update'));
    dispatch(setChangesDataList([]));
    dispatch(dispatchPagValue(1));
    dispatch(postSaveOrUpdate(null));
    dispatch(setPervSearchInvoiceRedux(response));
    dispatch(setSearchScreenTab(searchInvoiceAuditTabData));

    redirectURLLink(
      '/invoiceAuditsDetail',
      'Invoice Audits Detail',
      history,
      dispatch
    );
  }
};
    const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || manufacturerList === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows?.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
      }
    }, [gridApi, manufacturerList]);
  return (
    <div
      className="tBillPanel custom-check tabs-container frr-invoice-audit"
      data-testid="invoice-audit-search"
    >
      <CustomSeparator parent1="Research" parent2="Invoice Audits" />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesFromRedux.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}
      {!fullScreenView && (
        <div className="row mb-2">
          <div className="col-6 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="filter-plan-by-radio-btn-plan"
              id="filter-plan-by-radio-btn-action"
              labelName={radioGroupLabelNamePlan}
              required
              reqColor
              optionList={planTypeOptions}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
                if (state.selectBy === 'M') {
                  getManufactureListData('rebateProgramCd', null);
                }
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-6 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="filter-plan-by-radio-btn-atype"
              id="filter-plan-by-radio-btn-action"
              labelName={radioGroupLabelNameAudit}
              required
              reqColor
              optionList={[
                { name: 'All', value: 'ALL' },
                { name: 'Invoice', value: 'INV' },
                { name: 'Special', value: 'SPC' },
                { name: 'Selected', value: 'Selected' },
              ]}
              defaultValue={state && state.auditTypeCd}
              filterAction={(e) => handleOnChangeEvent(e, 'auditTypeCd')}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-6 pl-0 frr-invoice-column-field">
            <div className="frr-mui-custom-form-width-45per">
              <div className="form-wrapper">
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="rebate_program-ia"
                    id="rebate_program"
                    label={rebateProgramLabelName}
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                          )
                        : null
                    }
                    helperText={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      ),
                    ]}
                    error={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />

                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="check_quarter_ia"
                    id="check_by_invoice_quater"
                    required
                    label={quarterLabelName}
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 6 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.quarterValue}
                    onChange={(e) => {
                      handleOnChangeEvent(e.target.value, 'quarterValue');
                    }}
                    onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                    className={
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                        ? _.map(
                            errorMessagesFromRedux.searchScreenErrors,
                            (l) =>
                              l.field === 'quarter' ? 'mandate-fields' : null
                          )
                        : null
                    }
                    helperText={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) => (l.field === 'quarter' ? l.message : null)
                            )
                          : null
                      ),
                    ]}
                    error={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) => (l.field === 'quarter' ? l.message : null)
                            )
                          : null
                      ),
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 ">
            <div className="row">
              <div className="col-6 pr-0 mt-n2">
                <FormControlLabel
                  className="ml-0 mt-5 frr-no-wrap"
                  data-testid="checked_ia"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Include Cleared Audits"
                  value={state.clearedIndex}
                  checked={state.clearedIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'clearedIndex')
                  }
                />
              </div>
              {state && state.auditTypeCd === 'Selected' ? (
                <div className="col-6 pl-0 frr-mui-custom-form-width-96per">
                  <div className="form-wrapper">
                    <div className="mui-custom-form with-select ">
                      <TextField
                        data-testid="selec_audit_type_ia"
                        label="Selected Audit Type"
                        id="SelectedAuditType"
                        name="selectedAuditType"
                        fullWidth
                        select
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'selectedAuditType' }}
                        InputLabelProps={{ shrink: true }}
                        value={state && state.selectedAuditType}
                        onChange={(e) => {
                          handleOnChangeEvent(
                            e.target.value,
                            'selectedAuditType'
                          );
                        }}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {commonDropdownList && commonDropdownList?.length > 0
                          ? commonDropdownList?.map((item) => {
                              return (
                                <MenuItem
                                  key={item.codeValue}
                                  value={item.codeValue}
                                >
                                  {`${item.codeValue} | ${item.longDescription}`}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-6 frr-reset-radioBtnGroup-padding">
            <RadioGroupComponent
              data-testid="filter-plan-by-radio-btn-select-by"
              id="filter-plan-by-radio-btn-action"
              labelName={radioGroupLabelNameSelectBy}
              required
              reqColor
              optionList={[
                { name: 'Manufacturer', value: 'M' },
                { name: 'NDC', value: 'NDC' },
                { name: 'Select All For Above Criteria', value: 'A' },
              ]}
              defaultValue={state && state.selectBy}
              filterAction={(e) => {
                if (e !== 'M') {
                  setSelectManufacturer({});
                }
                handleOnChangeEvent(e, 'selectBy');
              }}
              className=""
            />
          </div>
          {(state && state.selectBy === 'A') ||
          (state && state.selectBy === 'M') ? (
            <div className="col-6 pr-0">
              <div className="mui-custom-form input-md frr-checkinvoice-search text-right frr-width-75per">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="view_detail_ia"
                  type="button"
                  onClick={() => {
                    let localErr = errorMessagesFromRedux?.searchScreenErrors
                      ? errorMessagesFromRedux?.searchScreenErrors
                      : [];
                    const reTest = /[1-4]{1}[qQ]{1}\d{4}$/;
                    const reTest2 = /[1-4]{1}[qQ]{1}\d{2}$/;
                    if (
                      state.rebateProgramCd !== null &&
                      state.rebateProgramCd !== '-1' &&
                      state.quarterValue !== '' &&
                      (reTest.test(state.quarterValue) ||
                        reTest2.test(state.quarterValue))
                    ) {
                      localErr = localErr.filter(
                        (item) =>
                          item.field !== 'rebateProgramCd' &&
                          item.field !== 'quarter'
                      );
                      if (state.selectBy === 'M') {
                        if (
                          selectManufacturer &&
                          Object.keys(selectManufacturer).length > 0
                        ) {
                          localErr = localErr.filter(
                            (item) =>
                              item.field !== 'rebateProgramCd' &&
                              item.field !== 'quarter' &&
                              item.field !== 'NoSelectedRow'
                          );
                          handleViewDetailFunction(selectManufacturer);
                        } else {
                          localErr = localErr.filter(
                            (item) =>
                              item.field !== 'rebateProgramCd' &&
                              item.field !== 'quarter'
                          );
                          localErr.push({
                            field: 'NoSelectedRow',
                            errorType: 'NoSelectedRow',
                            message: constantMessageData.NOT_SELECTED_ROW,
                          });
                        }
                      } else {
                        handleViewDetailFunction();
                      }
                    } else if (
                      state?.rebateProgramCd === null ||
                      state?.rebateProgramCd === undefined ||
                      state?.rebateProgramCd === '-1'
                    ) {
                      localErr = localErr?.filter(
                        (item) => item.field !== 'rebateProgramCd'
                      );
                      localErr.push({
                        field: 'rebateProgramCd',
                        errorType: 'rebateRequired',
                        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
                      });
                    } else if (state.quarterValue === '') {
                      localErr = localErr.filter(
                        (item) => item.field !== 'quarter'
                      );
                      localErr.push({
                        field: 'quarter',
                        errorType: 'required',
                        message: constantMessageData.QUARTER_VALUE_REQUIRED,
                      });
                    } else if (!checkQuarterValidation(state.quarterValue)) {
                      localErr = localErr.filter(
                        (item) => item.field !== 'quarter'
                      );
                      localErr.push({
                        field: 'quarter',
                        errorType: 'invalidFormat',
                        message:
                          constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
                      });
                    }
                    dispatch(
                      handleErrorMessages({
                        searchScreenErrors: [...new Set(localErr)],
                        detailScreenErrors:
                          errorMessagesFromRedux?.detailScreenErrors
                            ? errorMessagesFromRedux?.detailScreenErrors
                            : [],
                      })
                    );
                  }}
                >
                  {' '}
                  <SVGComponent iconName="Icon-view" /> {'  '} View Invoice
                  Audit Detail
                </Button>
                <div className="mt-1">
                  <DisplayErrorMessages
                    errorMessages={[
                      ...new Set(
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.filter(
                              errorMessagesFromRedux?.searchScreenErrors,
                              (l) =>
                                // l.field === 'resultNotFound' ||
                                l.field === 'NoSelectedRow' && l.message
                            ).map((val) => val.message)
                          : []
                      ),
                    ]}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
      <div>
        {state && state.selectBy === 'M' ? (
          <TableGrid
            ref={gridRef}
            data-testid="manufacturer-ia-table"
            rowSelection="single"
            gridCall={onGridReady}
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={manufacturerList}
            columnDefs={TableHeaderForManufacturer}
            onSelect={(e) => {
              setSelectManufacturer(e.data);
            }}
            cellClickedListener={(e) => {
              handleViewDetailFunction(e.data);
              setSearchInvoiceAudit({
                state: state,
                fullScreenView: fullScreenView,
                selectRowIndex: e.rowIndex,
              });
            }}
            exportFile
            animateRows
            sideBar={false}
            helpMessage="* On Double Click of Results, system should navigate to Detail page"
            fileName="Invoice Audits-Manufacturer"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
          />
        ) : state && state.selectBy === 'NDC' ? (
          <SearchTypeComponent
            id="Invoice-Audits"
            data-testid="search-type-ia"
            viewDetailButtonName="View Invoice Audit Detail"
            searchType={searchType}
            setSearchType={setSearchType}
            getErrorsFromSearchTypeComponent={getErrorsFromSearchTypeComponent}
            errorMsgFromSearchType={errorMsgFromSearchType}
            setLabelerFullScreen={setLabelerFullScreen}
            labelerFullScreen={labelerFullScreen}
            setNdcLeftFullScreen={setNdcLeftFullScreen}
            ndcLeftFullScreen={ndcLeftFullScreen}
            setNdcRightFullScreen={setNdcRightFullScreen}
            ndcRightFullScreen={ndcRightFullScreen}
            handleViewDetailFunction={handleViewDetailFunction}
            setlabelerSelectedRow={setlabelerSelectedRow}
            labelerSelectedRow={labelerSelectedRow}
            setNdcLeftSelectedRows={setNdcLeftSelectedRows}
            ndcLeftSelectedRows={ndcLeftSelectedRows}
            setNdcRightSelectedRows={setNdcRightSelectedRows}
            ndcRightSelectedRows={ndcRightSelectedRows}
            setlabelerTableData={setlabelerTableData}
            labelerTableData={labelerTableData}
            setNdcLeftTableData={setNdcLeftTableData}
            ndcLeftTableData={ndcLeftTableData}
            setNdcRightTableData={setNdcRightTableData}
            ndcRightTableData={ndcRightTableData}
            setNdcSearchVal={setNdcSearchVal}
            ndcSearchVal={ndcSearchVal}
            setNdcNameSearchVal={setNdcNameSearchVal}
            ndcNameSearchVal={ndcNameSearchVal}
          />
        ) : null}
         <CommonModal
  open={confirmAction}
  viewAction
  className="dialog-420"
  viewHeader
  onOk={() => {
    if (pendingPayload) {
      const { Obj, drugSeqArr } = pendingPayload;
      const limitedList = drugSeqArr.slice(0, 1000);
      callSearchAPI(Obj, limitedList);
      setPendingPayload(null);
    }
    setConfirmAction(false);
  }}
  okTitle="Ok"
  closeTitle="Cancel"
  onClose={() => setConfirmAction(false)}
  modalTitle="Confirmation Dialog"
  childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
/>
      </div>
    </div>
  );
};
export default InvoiceAuditsSearch;
